/* istanbul ignore file */
import React, { useEffect } from 'react';
import { FormProvider, TextArea, useForm } from 'framework/form';
import opportunityValidationSchema from 'domain/sales/opportunity/createupdate/opportunityValidation';
import { isEqual } from 'lodash';
import ClosedReasonDropdown from 'domain/sales/opportunity/shared/input/ClosedReasonDropdown';

const ClosedReasonInputs = ({
  setFormErrors,
  setFormData,
  formData,
  formErrors,
}: {
  setFormErrors: (errors: Dictionary<string[]>) => void;
  setFormData: (data: Dictionary<any>) => void;
  formData: Dictionary<any>;
  formErrors: Dictionary<string[]>;
}) => {
  const contextValue = useForm({
    initialData: formData,
    submitFormFunc: () => Promise.resolve({}),
    getValidationSchemaFunc: () => Promise.resolve({ closedReason: opportunityValidationSchema.closedReason }),
  });

  useEffect(() => {
    if (!isEqual(contextValue.formErrors, formErrors)) {
      setFormErrors(contextValue.formErrors);
    }
    // Suppressed warnings because we only need to call useEffect callback if contextValue.formErrors is changed.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contextValue.formErrors]);

  useEffect(() => {
    if (!isEqual(contextValue.data, formData)) {
      setFormData(contextValue.data);
    }
    // Suppressed warnings because we only need to call useEffect callback if contextValue.data is changed.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contextValue.data]);

  return (
    <FormProvider value={contextValue}>
      <ClosedReasonDropdown
        type="PRIMARY"
        source="closedReason.primaryReason"
        stageSource="stateStep"
        label="Primary reason for closed status"
        placeholder="Choose primary closed reason"
        tooltip="Select the primary reason of why the Opportunity has been Won (Lost)."
      />
      <ClosedReasonDropdown
        type="SECONDARY"
        source="closedReason.secondaryReason"
        stageSource="stateStep"
        label="Secondary reason for closed status"
        placeholder="Choose secondary closed reason"
        tooltip="Select the secondary reason of why the Opportunity has been Won (Lost)."
      />
      <TextArea
        label="Closed summary"
        source="closedReason.summary"
        tooltip="Provide a summary of why the Opportunity was Won (Lost). Quote prospect's feedback, when available."
      />
    </FormProvider>
  );
};

export default ClosedReasonInputs;
